define.alias("shared/helpers/format-number-with-suffix", "media/helpers/format-number-with-suffix");